module.exports = __webpack_public_path__ + "static/enterprise-07004e62f8e2f38a8d1c621e72b6166b.png";